import React from "react";
import { Helmet } from "react-helmet";

const getHelmetContent = () => {
  return {
    meta: [
      { name: "keywords", content: "ThinkQuotient specializes in IT development and as well as in freshers training. angular js classes in pune, angular training in pune, angular course in pune, angular course online, angular full course, best angular course, angular online training, angular training institute, data analyst course in pune, data analysis courses online, best courses on data analytics, best data analyst course in pune, data analysis certification courses, data science course, data scientist course in pune, data science courses fees, data science classes in pune, data science courses near me, data science online course, best data science courses, good data science courses, data science course in pune with placement assistance, best data science course in pune, data scientist classes near me, data science certification course, data science analytics course, data science and analytics course, dot net classes in pune, dot net course duration and fees in pune, full stack dot net developer course, course for full stack developer, full stack developer course in pune, full stack web dev course, full stack development course, full stack developer course near me, full stack developer classes in pune, best full stack developer course, best full stack developer course in pune, full stack developer classes near me, full stack development classes in pune, hibernate course online, hibernate online training, html language course, html full course, html css course, html course with certificate, best html css course, html classes in pune, java certification in pune, java language classes in pune, java training course in pune, java online classes, java programming language online course, java full course, best java classes in pune, complete java classes in pune, java developer courses, java full stack developer course in pune, full stack java developer course in pune, best course for java, online java training in pune, java programming course, python classes in pune, python programming classes near me, python language online course, python programming online course, python training online, full course python, python course near me, python programming online, best python course, best python programming course, python training in pune, full stack python developer course, best python training in pune, data science with python course, online python training in pune, python full stack developer course in pune, react js classes in pune, best react js courses, online react courses, react classes in pune, react online classes, online react js training in pune, react js full course, online reactjs training in pune, react js training in pune, react course in pune, react best course, react developer course, spring boot online course, spring boot training online, sql course, sql classes in pune, online sql classes, sql free certification course, sql lessons online, best course sql, best sql classes, sql training in pune, sql course with certificate, web dev classes, web development courses, web programming course, website development classes, full stack web development course, web development classes in pune, course web developer, best courses web development, best web development course, online web development classes, full course of web development, web developer courses near me, web development full course, online website development course, ai courses, artificial intelligence classes, machine intelligence course, generative ai courses, ai courses in pune, ai and ml courses, ai classes in pune, ai training in pune, generative ai training, ai online training, online generative ai course, knime courses, knime online course, knime training, knime training course " },
      { name: "description", content: "Think Quotient is an online learning and teaching marketplace with over multiple courses and 10000 students. Learn programming, data science and more." },
      { name: "viewport", content: "width=device-width, initial-scale=1.0" },
      { name: "language", content: "English" },
    ],

    script: [
      <script type="application/ld+json">
        {`
            {
              "@context": "http://www.schema.org",
              "@type": "ProfessionalService",
              "name": " Professional Training Institute in Pune",
              "url": "https://www.thinkquotient.ai/",
              "logo": "https://www.thinkquotient.ai/assets/images/envelop.png",
              "image": "https://thinkquotient.ai/assets/images/envelop.png",
              "description": "ThinkQuotient specializes in IT development and as well as in freshers training.",
              "telephone": "+917030055128",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": " 2nd Floor, Nirmitee Elite, 103, Law College Rd, next to Starbucks, Shanti Sheela Society, Apex Colony, Erandwane, Pune",
                "addressLocality": "Pune",
                "addressRegion": "Maharashtra",
                "postalCode": "411004",
                "addressCountry": "India"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": "18.51455",
                "longitude": "73.82876"
              },
              "sameAs": [
                "https://www.facebook.com/ThinkQuotient-Software-Pvt-Ltd-425080191407703/",
                "https://twitter.com/ThinkQuotient",
                "https://www.linkedin.com/company/thinkquotient/",
                "https://www.instagram.com/thinkquotient_software/?igshid=1j31daue8ovci"
              ]
            }
          `}
      </script>,

      // Updated Google Tag Manager script
      <script>
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-KTNBVH9V');
        `}
      </script>,

      // Google Analytics tracking scripts
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-143016865-1"></script>,
      <script>
        {`
          window.dataLayer = window.dataLayer || []; 
          function gtag() { dataLayer.push(arguments); } 
          gtag('js', new Date()); 
          gtag('config', 'UA-143016865-1');
        `}
      </script>,

      <script async src="https://www.googletagmanager.com/gtag/js?id=G-BSFPPN5E9D"></script>,
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', 'G-BSFPPN5E9D');
        `}
      </script>,

      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-574047969"></script>,
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', 'AW-574047969');
        `}
      </script>,
    ],

    noscript: [
      // Google Tag Manager noscript fallback
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-KTNBVH9V"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>,
    ],
  };
};

export default getHelmetContent;
